import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FiSearch } from "react-icons/fi";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import { ROUTES } from "../../../routes/routeKeys";
import SearchResults from "./SearchResults";

const HeaderSearch = () => {
  const [config] = useAuth();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!query.trim()) {
      setResults(null);
      return;
    }

    const timer = setTimeout(() => {
      fetchResults(query, selectedFilter);
    }, 500);

    return () => clearTimeout(timer);
  }, [query, selectedFilter]);

  const fetchResults = (searchQuery, filterType) => {
    setLoading(true);
    const typeParam = filterType === "all" ? "" : `&type=${filterType}`;
    axios
      .get(`${BASE_URL}/global-search?query=${encodeURIComponent(searchQuery)}${typeParam}&limit=10`, config)
      .then((res) => {
        setResults(res.data?.data);
      })
      .catch((err) => {
        console.error("Global search error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleNavigate = (type, id) => {
    setIsDropdownOpen(false);
    setQuery("");
    if (type === "property") {
      navigate(ROUTES.PROPERTY_DETAILS.replace(":id", id));
    } else if (type === "contact") {
      navigate(ROUTES.CONTACT_DETAILS.replace(":id", id));
    } else if (type === "company") {
      navigate(ROUTES.COMPANY_DETAILS.replace(":id", id));
    }
  };

  const handleFocus = () => {
    setIsDropdownOpen(true);
  };

  return (
    <div ref={wrapperRef} className="relative w-[300px]">
      <div className="flex items-center gap-2 border border-gray-300 rounded-md px-3 h-[38px] bg-white text-gray-400 focus-within:border-[#2D5B30] focus-within:text-gray-700 transition">
        <FiSearch className="w-4 h-4" />
        <input
          type="text"
          className="flex-1 outline-none body-N dark-H bg-transparent border-0 ring-0 shadow-none m-0 p-0 focus:ring-0 focus:outline-none"
          placeholder="Search... (Ctrl+F)"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            if (!isDropdownOpen) setIsDropdownOpen(true);
          }}
          onFocus={handleFocus}
        />
      </div>

      {isDropdownOpen && (query.trim().length > 0 || loading) && (
        <div className="absolute top-full left-0 mt-2 w-[500px] bg-white border border-gray-200 rounded-lg shadow-xl z-[99999] overflow-hidden">
          <SearchResults 
            results={results}
            query={query}
            loading={loading}
            handleNavigate={handleNavigate}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            containerHeight="max-h-[400px]"
          />
        </div>
      )}
    </div>
  );
};

export default HeaderSearch;
